import { render, staticRenderFns } from "./resumezp.vue?vue&type=template&id=3cb80018&scoped=true&"
import script from "./resumezp.vue?vue&type=script&lang=js&"
export * from "./resumezp.vue?vue&type=script&lang=js&"
import style0 from "./resumezp.vue?vue&type=style&index=0&id=3cb80018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb80018",
  null
  
)

component.options.__file = "resumezp.vue"
export default component.exports